package org.catharsis.spendtel.core.api

interface AuthTokenProvider {
    suspend fun getIdToken(forceRefresh: Boolean = false): String
}
